import Link from '@mui/material/Link';
import { isMobileOnly } from 'react-device-detect';

import { equalOrThreeDashes } from './equalOrThreeDashes';
import { phone as phoneFormat } from './formats';

// mui param = temporary fix while refactoring to MUI - some parts of app still use old style (basic blue <a/> tag)
export const mailToLink = (email, mui = false) => {
	if (email) {
		const mailTo = `mailto:${email}`;
		return mui ? (
			<Link underline="none" href={mailTo}>
				{email}
			</Link>
		) : (
			<a href={mailTo}>{email}</a>
		);
	} else {
		return equalOrThreeDashes();
	}
};

export const phoneToLink = (num, mui = false) => {
	if (num && isMobileOnly) {
		const tel = `tel:${num}`;
		return mui ? (
			<Link underline="none" href={tel}>
				{phoneFormat(num)}
			</Link>
		) : (
			<a href={tel}>{phoneFormat(num)}</a>
		);
	} else {
		return equalOrThreeDashes(phoneFormat(num));
	}
};
